import Link from 'next/link';
import React, { memo } from 'react';

import { capitalizeFLetter } from '@/utils/helpers';
function AdsDetailsMoreInfo(props: { city: string }) {
  return (
    <div className="contact-me-row">
      <p className="more-add-panel mt-40">
        <span>MORE ADS OF:</span>
        <span>
          <Link title={props.city} href={`/search?city=${props.city}`}>
            Escorts in {capitalizeFLetter(props.city)}
          </Link>
        </span>
      </p>
      <div className="alert-msg-wrapper-c">
        <h6>
          <i className="247Torax-icon-shield"></i>
          <strong>Report Abuse</strong>
        </h6>
        <ul>
          <li>
            You can send an email to <strong>privacy.in@247torax.com</strong> to report for any improper use of images,
            report of intellectual property (for example telephone, e-mail, names and addresses).
          </li>
          <li>
            You can send an email to <strong>grievances@247torax.com</strong> to report for any kind of deemed illegal
            or any abusive content.
          </li>
        </ul>
      </div>

      <div className="bottom-content mt-40 p-det">
        <p>
          <strong>247torax.com Does Not Mediate in the Affairs Between Pleasure Seekers and Advertisers</strong>
        </p>
        <p>
          By visiting our website and using our adult classified ads, the VISITORS accept our Terms and Conditions of
          use, and the code of conducts we expect from our visitors to follow.
        </p>
        <p>
          The adult classified ads in 247Torax has been published by the advertisers under their complete
          responsibility. The advertisements are not subjected to any type of prior verification by 247Torax. This
          classified ad portal is not responsible regarding the veracity, legality, respect to the property right and
          possible displeasure with the public or moral order of the online contents entered by the user under any
          condition.
        </p>
        <p>
          247torax.com is a free adult classified ad portal that allow the publishers to promote their adult services.
          The ad portal is not supposed to intervene in any kind of relationship or settlement between the pleasure
          seekers and service providers.
        </p>
      </div>
    </div>
  );
}

export default memo(AdsDetailsMoreInfo);
